export { default } from './useLocalTheme'
